import React, { useState, useEffect } from 'react';
import {
  Box,
  Divider,
  Tab,
  Tabs,
  makeStyles,
  Container,
  Typography
} from '@material-ui/core';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import clsx from 'clsx';
import PopularQRCode from './PopularQRCode';
import CallQRCode from './CallQRCode';
import MessageQRCode from './MessageQRCode';
import SocialQRCode from './SocialQRCode';
import BusinessQRCode from './BusinessQRCode';
import AppsQRCode from './AppsQRCode';
import OtherQRCode from './OtherQRCode';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#e0ecf8',
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  mainTabContainer: {
    backgroundColor: '#e0ecf8'
  },
}));



const FreeQRCode = ({ className, ...rest }) => {
  const history = useHistory();
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(0);
  const location = useLocation();
  const { tabId } = useParams();


  useEffect(() => {
    if (tabId === 'popular-qrcode-free') {
      setCurrentTab(0);
    } else if (tabId === 'free-qrcode-for-calling') {
      setCurrentTab(1);
    } else if (tabId === 'free-qrcode-for-messages') {
      setCurrentTab(2);
    } else if (tabId === 'free-qrcode-for-social-media') {
      setCurrentTab(3);
    } else if (tabId === 'free-qrcode-for-business') {
      setCurrentTab(4);
    } else if (tabId === 'free-qrcode-for-app-store') {
      setCurrentTab(5);
    } else if (tabId === 'free-qrcode-for-anything') {
      setCurrentTab(6);
    } 
  }, [tabId]);

  const tabs = [
    { value: 0, label: 'Popular', param: 'popular-qrcode-free'},
    { value: 1, label: 'Call' , param: 'free-qrcode-for-calling'},
    { value: 2, label: 'Message', param: 'free-qrcode-for-messages'},
    { value: 3, label: 'Social', param: 'free-qrcode-for-social-media'},
    { value: 4, label: 'Business', param: 'free-qrcode-for-business'},
    { value: 5, label: 'Apps Download', param: 'free-qrcode-for-app-store'},
    { value: 6, label: 'Other', param: 'free-qrcode-for-anything'},
  ];


  const handleTabsChange = (event, value) => {
    const param = tabs.find(tab => tab.value === value).param;
    if (param) {
      const newUrl = `/tools/free-qrcode-generator/${param}`;
      history.push(newUrl);
      setCurrentTab(value);
    }
  };

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >

      <Container maxWidth="lg">
      <Typography
            variant="h1"
            align="center"
            color="textPrimary"
            >
           Free QR Code Generator
          </Typography>
       
          <Box mt={3}>
            <Tabs
              onChange={handleTabsChange}
              scrollButtons="auto"
              value={currentTab}
              variant="scrollable"
              textColor="secondary"
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}                 
                />
              ))}
            </Tabs>
          </Box>
          <Divider />
          <Box mt={5}>
            {currentTab === 0 && <PopularQRCode />}
            {currentTab === 1 && <CallQRCode />}
            {currentTab === 2 && <MessageQRCode />}
            {currentTab === 3 && <SocialQRCode />}
            {currentTab === 4 && <BusinessQRCode />}
            {currentTab === 5 && <AppsQRCode />}
            {currentTab === 6 && <OtherQRCode />}
          </Box>
      </Container>
    </div>
  );
};

export default FreeQRCode;
